(() => {
  const init = (root) => {
    if (!root || root.dataset.shopMenuReady) return;
    root.dataset.shopMenuReady = 'true';

    const header = root.querySelector('.header-main-w');
    const menuPairs = [...root.querySelectorAll('[data-shop-menu-trigger]')]
      .map((trigger) => ({
        trigger,
        menu: document.getElementById(trigger.getAttribute('aria-controls')),
      }))
      .filter((pair) => pair.menu);
    const mobileToggle = root.querySelector('[data-shop-mobile-toggle]');
    const mobileMenu = root.querySelector('.eltior-shop-mobile');
    const desktop = window.matchMedia('(min-width: 1000px)');
    let activePair;

    const show = (pair, key) => {
      const cards = [...pair.menu.querySelectorAll('[data-shop-feature-card]')];
      cards.forEach((card) => {
        const active = card.dataset.shopFeatureCard === key;
        card.toggleAttribute('data-active', active);
        card.inert = !active;
      });
    };
    const setOpen = (pair, open) => {
      if (!pair || (open && !desktop.matches)) return;
      const switching = open && activePair && activePair !== pair && activePair.menu.hasAttribute('data-open');
      if (switching) pair.menu.setAttribute('data-shop-menu-instant', '');
      if (open) {
        menuPairs.forEach((other) => {
          if (other === pair || !other.menu.hasAttribute('data-open')) return;
          other.menu.removeAttribute('data-open');
          other.menu.inert = true;
          other.trigger.setAttribute('aria-expanded', 'false');
        });
        activePair = pair;
      }
      pair.menu.toggleAttribute('data-open', open);
      pair.menu.inert = !open;
      pair.trigger.setAttribute('aria-expanded', String(open));
      header.toggleAttribute('data-shop-menu-open', open || menuPairs.some((other) => other.menu.hasAttribute('data-open')));
      if (switching) {
        requestAnimationFrame(() => requestAnimationFrame(() => pair.menu.removeAttribute('data-shop-menu-instant')));
      }
      if (!open && pair.menu.querySelector('[data-shop-feature-card][data-active]')) {
        const defaultCard = pair.menu.querySelector('[data-shop-feature-card][data-active]') || pair.menu.querySelector('[data-shop-feature-card]');
        if (defaultCard) show(pair, defaultCard.dataset.shopFeatureCard);
      }
      if (!open && activePair === pair) activePair = null;
    };

    if (header) {
      menuPairs.forEach((pair) => {
        const grid = pair.menu.querySelector('[data-shop-grid]');
        const cards = [...pair.menu.querySelectorAll('[data-shop-feature-card]')];
        const defaultCard = cards.find((card) => card.hasAttribute('data-active')) || cards[0];
        if (defaultCard) show(pair, defaultCard.dataset.shopFeatureCard);

        pair.trigger.addEventListener('mouseenter', () => {
          if (!desktop.matches) return;
          setOpen(pair, true);
        });
        pair.trigger.addEventListener('click', () => {
          // Hover opens the desktop menu. A subsequent click should keep it open.
          if (desktop.matches && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            setOpen(pair, true);
            return;
          }
          setOpen(pair, !pair.menu.hasAttribute('data-open'));
        });

        grid?.querySelectorAll('[data-shop-feature]').forEach((item) => {
          const activate = () => {
            if (cards.some((card) => card.dataset.shopFeatureCard === item.dataset.shopFeature)) show(pair, item.dataset.shopFeature);
          };
          item.addEventListener('mouseenter', activate);
          item.addEventListener('focus', activate);
        });
        grid?.addEventListener('mouseleave', () => {
          if (defaultCard) show(pair, defaultCard.dataset.shopFeatureCard);
        });
      });
      header.addEventListener('mouseenter', () => {
        root.removeAttribute('data-shop-glass');
      });
      header.addEventListener('mouseleave', () => {
        setOpen(activePair, false);
      });
      root.addEventListener('focusout', (event) => {
        if (activePair?.menu.hasAttribute('data-open') && !header.contains(event.relatedTarget)) setOpen(activePair, false);
      });
      document.addEventListener('pointerdown', (event) => {
        if (activePair?.menu.hasAttribute('data-open') && !header.contains(event.target)) setOpen(activePair, false);
      });
    }

    const setMobileOpen = (open) => {
      if (!mobileMenu || !mobileToggle) return;
      document.body.classList.toggle('mobile-menu-open', open);
      mobileToggle.classList.toggle('is-active', open);
      mobileToggle.setAttribute('aria-expanded', String(open));
      mobileToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      mobileMenu.inert = !open;
    };
    mobileToggle?.addEventListener('click', () => setMobileOpen(!document.body.classList.contains('mobile-menu-open')));
    mobileMenu?.querySelectorAll('[data-shop-accordion]').forEach((accordion) => {
      const button = accordion.querySelector('.eltior-shop-mobile__accordion-head');
      const body = accordion.querySelector('.eltior-shop-mobile__accordion-body');
      button?.addEventListener('click', () => {
        const willOpen = !accordion.hasAttribute('data-open');
        mobileMenu.querySelectorAll('[data-shop-accordion]').forEach((other) => {
          other.removeAttribute('data-open');
          other.querySelector('.eltior-shop-mobile__accordion-head')?.setAttribute('aria-expanded', 'false');
          other.querySelector('.eltior-shop-mobile__accordion-body').inert = true;
        });
        if (willOpen) {
          accordion.setAttribute('data-open', '');
          button.setAttribute('aria-expanded', 'true');
          body.inert = false;
        }
      });
    });
    mobileMenu?.querySelectorAll('[data-shop-shade]').forEach((chip) => {
      chip.addEventListener('click', () => {
        mobileMenu.querySelectorAll('[data-shop-shade]').forEach((other) => other.setAttribute('data-selected', String(other === chip)));
        const lipLink = mobileMenu.querySelector('[data-shop-lip-link]');
        const lipImage = mobileMenu.querySelector('[data-shop-lip-image]');
        const subtitle = mobileMenu.querySelector('[data-shop-lip-subtitle]');
        if (lipLink) lipLink.href = chip.dataset.shopShadeUrl;
        if (lipImage && chip.dataset.shopShadeImage) lipImage.src = chip.dataset.shopShadeImage;
        if (subtitle) subtitle.textContent = `Shade: ${chip.dataset.shopShadeName}`;
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      if (activePair?.menu.hasAttribute('data-open')) {
        const trigger = activePair.trigger;
        setOpen(activePair, false);
        trigger.focus();
      }
      if (document.body.classList.contains('mobile-menu-open')) {
        setMobileOpen(false);
        mobileToggle?.focus();
      }
    });
    desktop.addEventListener('change', () => {
      if (desktop.matches) setMobileOpen(false);
      else setOpen(activePair, false);
    });

    let lastY = window.scrollY;
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        const dy = y - lastY;
        lastY = y;
        ticking = false;
        if (!desktop.matches || y < 24) root.removeAttribute('data-shop-glass');
        else if (dy > 3) {
          root.setAttribute('data-shop-glass', '');
          setOpen(activePair, false);
        } else if (dy < -3) root.removeAttribute('data-shop-glass');
      });
    }, { passive: true });
  };

  const boot = () => document.querySelectorAll('[data-shop-menu-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
